<script>
    import { FlowRouter } from "meteor/ostrio:flow-router-extra";
</script>

<section class="aux-page aux-financing">
    <div class="aux-head">
        <p class="aux-eyebrow">Financing</p>
        <h1>Financing Solutions for Every Credit Story</h1>
        <p>
            We begin with your comfort zone for payments, then source the right
            vehicle and lender fit for your situation.
        </p>
    </div>

    <div class="aux-grid three">
        <article class="aux-panel metric">
            <p class="metric-label">Bank Lenders</p>
            <p class="metric-value">20</p>
        </article>
        <article class="aux-panel metric">
            <p class="metric-label">Private Lenders</p>
            <p class="metric-value">4</p>
        </article>
        <article class="aux-panel metric">
            <p class="metric-label">Approach</p>
            <p class="metric-value">Budget-First</p>
        </article>
    </div>

    <article class="aux-panel">
        <h2>How We Work</h2>
        <ul class="aux-list">
            <li>Start with the payment range that fits your monthly plan.</li>
            <li>Match lender options to your credit profile and goals.</li>
            <li>Source the right vehicle once approvals are in place.</li>
        </ul>
        <div class="aux-actions">
            <button onclick={() => FlowRouter.go("/application")}
                >Start Application</button
            >
            <button
                class="secondary-btn"
                onclick={() => FlowRouter.go("/contact")}>Ask A Question</button
            >
        </div>
    </article>
</section>
